import { render, staticRenderFns } from "./set-rules.vue?vue&type=template&id=200b0b0c&scoped=true"
import script from "./set-rules.vue?vue&type=script&lang=js"
export * from "./set-rules.vue?vue&type=script&lang=js"
import style0 from "./set-rules.vue?vue&type=style&index=0&id=200b0b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b0b0c",
  null
  
)

export default component.exports